const comments = [
  {
    id: 323,
    type: 'user-comment',
    userId: 2,
    username: 'Pensuaco',
    profilePic: '',
    postId: 47,
    comment: 'lol what is this',
    date: '2020-04-07T03:22:59',
  },
  {
    id: 224,
    type: 'user-comment',
    userId: 2,
    username: 'Pensuaco',
    profilePic: '',
    postId: 92,
    comment: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Qui, accusantium!',
    date: '2020-03-07T03:22:59',
  },
  {
    id: 425,
    type: 'user-comment',
    userId: 2,
    username: 'K O R A R U',
    profilePic: '',
    postId: 169,
    comment:
      "Woah he is so big!! Can't wait to see him in person!! Big guy! thanks for sharing K O R A R U",
    date: '2020-02-07T03:22:59',
  },
];

export default comments;
